export default __webpack_public_path__ + "static/media/news.1a018bd2.svg";